/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */

import getQueryParameters from './urlparser';
import NumberFormatter from '../cldr/number-formatter';

const formatters = {};

const formatSliderValue = (value, unit = '') => {
  const num = parseFloat(value);

  if (Number.isNaN(num)) {
    return `${value}${unit}`;
  }

  let formatted;

  if (num === 0) {
    formatted = '0';
  } else if (Math.abs(num) < 0.001) {
    formatted = num.toFixed(6).replace(/\.?0+$/, '');
  } else if (num < 1) {
    formatted = num.toFixed(3).replace(/\.?0+$/, '');
  } else {
    formatted = num.toFixed(2).replace(/\.?0+$/, '');
  }

  return `${formatted}${unit}`;
};

const computeSliderStep = (min, max) => {
  const range = parseFloat(max) - parseFloat(min);

  if (!Number.isFinite(range) || range <= 0) {
    return 0.001;
  }

  const rawStep = range / 100;
  const magnitude = 10 ** Math.floor(Math.log10(rawStep));
  const step = Math.ceil(rawStep / magnitude) * magnitude;

  return Math.max(step, 0.000001);
};

const displayLabelBlock = (formatterId, displayBlock, min, max, facetRangeBlock, unit = '') => {
  if (formatters[formatterId] === undefined) {
    displayBlock.text(
      displayBlock.text().replace(
        /([^\d]*)(?:[\d\s.,]+)([^\d]+)(?:[\d\s.,]+)(.*)/,
        `$1${formatSliderValue(min, unit)}$2${formatSliderValue(max, unit)}$3`,
      ),
    );
  } else {
    displayBlock.text(
      `${formatters[formatterId].format(min)} - ${formatters[formatterId].format(max)}`,
    );
  }
  if (facetRangeBlock && facetRangeBlock.length) {
    facetRangeBlock.find('.js-facet-min').text(formatSliderValue(min, unit));
    facetRangeBlock.find('.js-facet-max').text(formatSliderValue(max, unit));
  }
};

/**
 * Refresh facets sliders
 */
const refreshSliders = () => {
  $('.faceted-slider').each(function initializeSliders() {
    const $el = $(this);
    const sliderId = $el.data('slider-id');
    const values = $el.data('slider-values');
    const specifications = $el.data('slider-specifications');
    const $displayBlock = $el.find(`#facet_label_${sliderId}`);
    const $sliderRange = $el.find(`#slider-range_${sliderId}`);

    if (specifications !== null && specifications !== undefined) {
      formatters[sliderId] = NumberFormatter.build(specifications);
    }

    const $facetRangeBlock = $sliderRange.siblings('.facet-range');

    const sliderMin = parseFloat($el.data('slider-min'));
    const sliderMax = parseFloat($el.data('slider-max'));
    const sliderUnit = $el.data('slider-unit') || '';
    const sliderValues = [
      values === null ? sliderMin : parseFloat(values[0]),
      values === null ? sliderMax : parseFloat(values[1]),
    ];

    displayLabelBlock(
      sliderId,
      $displayBlock,
      sliderValues[0],
      sliderValues[1],
      $facetRangeBlock,
      sliderUnit,
    );

    if ($sliderRange.hasClass('ui-slider')) {
      $sliderRange.slider('destroy');
    }

    $sliderRange.slider({
      range: true,
      min: sliderMin,
      max: sliderMax,
      step: computeSliderStep(sliderMin, sliderMax),
      values: sliderValues,
      stop(event, ui) {
        const nextEncodedFacetsURL = $el.data('slider-encoded-url');
        const urlsSplitted = nextEncodedFacetsURL.split('?');
        let queryParams = [];

        // Retrieve parameters if exists
        if (urlsSplitted.length > 1) {
          queryParams = getQueryParameters(urlsSplitted[1]);
        }

        let found = false;
        queryParams.forEach((query) => {
          if (query.name === 'q') {
            found = true;
          }
        });

        if (!found) {
          queryParams.push({name: 'q', value: ''});
        }

        // Update query parameter
        queryParams.forEach((query) => {
          if (query.name === 'q') {
            // eslint-disable-next-line
            query.value += [
              query.value.length > 0 ? '/' : '',
              $el.data('slider-label'),
              '-',
              $el.data('slider-unit'),
              '-',
              ui.values[0],
              '-',
              ui.values[1],
            ].join('');
          }
        });

        const requestUrl = [
          urlsSplitted[0],
          '?',
          $.param(queryParams),
        ].join('');

        prestashop.emit(
          'updateFacets',
          requestUrl,
        );
      },
      slide(event, ui) {
        displayLabelBlock(
          sliderId,
          $displayBlock,
          ui.values[0],
          ui.values[1],
          $facetRangeBlock,
          sliderUnit,
        );
      },
    });
  });
};

export default refreshSliders;
